import { render, staticRenderFns } from "./ImportArtistPayment.vue?vue&type=template&id=2a2e5e9d"
import script from "./ImportArtistPayment.vue?vue&type=script&lang=js"
export * from "./ImportArtistPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports